import { RouteRecordRaw } from 'vue-router';
import { AdminBranchCreatePage } from '@/pages/admin';

export const routeName = 'AdminCriarFilial';

export const route: RouteRecordRaw = {
  path: 'filiais/criar-filial',
  name: routeName,
  component: AdminBranchCreatePage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Criar Filial',
    permissions: [{ action: 'manageBranches', subject: 'Admin' }],
  },
};
